import {FiTrash2} from "react-icons/fi";
import { useTranslation } from "react-i18next";
import styles from "./ExamBaseDeleteQuestion.module.css";

const ExamBaseDeleteQuestion = ({ isOpen, onConfirm, onCancel, disabled }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <div className={styles.iconWrap}>
                        <FiTrash2 className={styles.icon} aria-hidden />
                    </div>
                    <h3 className={styles.title}>{t("common.deleteConfirmTitle")}</h3>
                </div>

                <p className={styles.message}>
                    {t("modals.deleteQuestionMessage")}
                </p>

                <div className={styles.actions}>
                    <button
                        type="button"
                        className={styles.cancelBtn}
                        onClick={onCancel}
                    >
                        {t("common.cancel")}
                    </button>
                    <button
                        type="button"
                        className={styles.confirmBtn}
                        onClick={onConfirm}
                        disabled={disabled}
                    >
                        {t("common.delete")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExamBaseDeleteQuestion;
